const apiUrl = process.env.REACT_APP_API_URL || "https://allof.deprakoso.com";

export default apiUrl;